import "@react-three/fiber"

export function SimpleImage(props: any) {
  return <img src={props.src} alt="" />
}
